import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b86c87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "content-header__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contentProviderHelper.route)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "content-header__link",
          to: _ctx.contentProviderHelper.route
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              (_ctx.contentProviderHelper.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.contentProviderHelper.label) + ": " + _toDisplayString(_ctx.contentProviderHelper.title), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, " Voltar "))
            ])
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}